
export function Footer() {
    return (
        <footer>
            <span>© 2026 Arztpraxis von Gabriele Wagner für Allgemeinmedizin · Rüsselsheim am Main · Eingetragen in der Landesärztekammer Hessen </span>
        </footer>
    );
}
